import * as Helpers from "@/helpers";

export default {
  categoryPreviewUrl(state) {
    return state.previewUrl;
  },
  categoryPageNum(state) {
    return state.page;
  },
  categorySearchValue(state) {
    return state.search;
  },
  categoryInfo(state) {
    return state.categoryInfo;
  },
  categorySlugOptions(state) {
    let list = state.categoryInfo;
    list = Helpers.searchCategoryTableFilterHelper(
      state.categorySlugOptionsSearch,
      list
    );
    return list;
  },
  filteredCategoryInfo(state) {
    let list = state.categoryInfo;
    list = Helpers.searchCategoryTableFilterHelper(state.search, list);
    return list;
  },
  exsitCategoryName(state) {
    return state.existCategories;
  },
  categoryInstance(state) {
    return state.categoryInstance;
  },
  categoryErrors(state) {
    return state.error;
  },
  categorySuccess(state) {
    return state.success;
  },
  categoryLoading(state) {
    return state.loading;
  },
  categoryAllAttributes(state) {
    return state.categoryAllAttributes;
  },
  operationMode(state) {
    return state.operation;
  }
};
